import React from 'react';
import { Flex, Input, Text } from '@chakra-ui/react';

export type CsTextProps = {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;

  pillBg?: string;
  pillBorderColor?: string;
  pillShadow?: string;
  textColor?: string;

  // circleBg?: string;
  // circleBorderColor?: string;
  // iconColor?: string;

  height?: string | number;
  minWidth?: string | number;
  // circleSize?: string | number;

  isDisabled?: boolean;
  allowEmpty?: boolean;
  maxLength?: number;
  // rightIcon?: React.ReactNode;
};

function sanitizeDecimalInput(input: string, maxLength?: number) {
  if (!input) return '';

  let next = input.replace(/\s+/g, '');

  // troca vírgula por ponto
  next = next.replace(/,/g, '.');

  // mantém apenas dígitos, ponto e hífen
  next = next.replace(/[^0-9.-]/g, '');

  // hífen só no início
  const isNegative = next.startsWith('-');
  next = next.replace(/-/g, '');
  if (isNegative) {
    next = `-${next}`;
  }

  // apenas um ponto decimal
  const parts = next.split('.');
  if (parts.length > 2) {
    next = `${parts[0]}.${parts.slice(1).join('')}`;
  }

  // limita para 2 casas decimais
  const negativePrefix = next.startsWith('-') ? '-' : '';
  const unsignedValue = negativePrefix ? next.slice(1) : next;
  const [integerPart = '', decimalPart] = unsignedValue.split('.');

  let finalValue = negativePrefix + integerPart;

  if (unsignedValue.includes('.')) {
    finalValue += `.${(decimalPart || '').slice(0, 2)}`;
  }

  if (typeof maxLength === 'number' && maxLength >= 0) {
    finalValue = finalValue.slice(0, maxLength);
  }

  return finalValue;
}

export function CsInput({
  label,
  value,
  onChange,
  placeholder,
  pillBg = 'gray.100',
  pillBorderColor = 'gray.100',
  pillShadow = 'sm',
  textColor = 'black',
  height = '40px',
  minWidth = '250px',
  isDisabled = false,
  allowEmpty = true,
  maxLength
}: CsTextProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let next = sanitizeDecimalInput(e.target.value, maxLength);

    if (!allowEmpty && (next === '' || next === '-')) {
      next = '0';
    }

    onChange(next);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData.getData('text');
    const next = sanitizeDecimalInput(pasted, maxLength);

    e.preventDefault();

    let finalValue = next;
    if (!allowEmpty && (finalValue === '' || finalValue === '-')) {
      finalValue = '0';
    }

    onChange(finalValue);
  };

  return (
    <Flex align="center" gap={4} w="100%">
      {label ? (
        <Text fontSize="2xl" color="gray.500" lineHeight="1" whiteSpace="nowrap">
          {label}
        </Text>
      ) : null}

      <Flex
        align="center"
        justify="space-between"
        bg={pillBg}
        border="1px solid"
        borderColor={pillBorderColor}
        borderRadius="999px"
        h={height}
        w="100%"
        minW={minWidth}
        pl="24px"
        boxShadow={pillShadow}
        cursor={isDisabled ? 'not-allowed' : 'text'}
        opacity={isDisabled ? 0.6 : 1}
      >
        <Input
          value={value}
          onChange={handleChange}
          onPaste={handlePaste}
          placeholder={placeholder}
          isDisabled={isDisabled}
          variant="unstyled"
          inputMode="decimal"
          fontSize="md"
          fontWeight="500"
          color={textColor}
          lineHeight="1"
          pr={2}
        />
      </Flex>
    </Flex>
  );
}

export default CsInput;